/**
 * Welcome to hell.
 * We are recreating the search functionality of the old site...
 * Get list of search documents.
 * Allow to choose a search filter option in nav
 * Search results should autopopulate
 * with associated post type  next to it.
 * If clicked, go straight to clicked resource
 * if searched, return search results based on filter
 * This is going to suck
 *  */
import Fuse from "fuse.js";
/* Utility: Truncate Text */
function truncate_text(str = "", length = 0) {
  return str.length > length ? str.substring(0, length - 3) + "..." : str;
}

export function navSearch($) {
  $("#js-nav-search-select").on("change", function (e) {
    // console.log("e.target.value", e.target.value);
    init_data(e.target.value);
  });

  function init_search_forms(search_data = []) {
    $('ul.ui-autocomplete').addClass('border border-theme-gray shadow-lg');
    $("#s")
      .autocomplete({
        // source: availableTags
        source: function (request, response) {
          // console.log("request: ", request);
          // console.log("search_data: ", search_data);
          var f = new Fuse(search_data, {
            keys: ["value", "label", "desc", "icon", "href"],
          });
          var result = f.search(request.term);
          response(result);
        },
      }).addClass( "" )
      .autocomplete("instance")._renderItem = function (ul, i) {
      const item = i.item || {};
      return $("<li class=' w-full p-0'>")
        .append(
          `<a href="${item.href}" class=" w-full relative p-0">
          <div class="relative hover:bg-gray-300 py-1 flex">
          <div class="text-theme-red font-bold relative w-24">${item.desc}</div><div>${truncate_text(item.label, 45)}</div>
          </div></a>`
        )
        .appendTo(ul);
    };
  }

  function init_data(scope = "all") {
    const search_data_request = $.ajax({
      url: window.isolaVars.ajaxurl,
      data: {
        action: "isola_get_search_index_data",
      },
      dataType: "json",
    });

    // When done
    search_data_request.done(function (data) {
      // console.log("data: ", data);
      if (data.result === "success") {
        init_search_forms(data.search_data[scope]);
      }
    });
  }

  init_data();
}
